<header id="header " class="public-header">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <img class="img-logo" src="assets/images/logo.png" alt="MEGA AUTOS" />
                <nav class="header-menu">
                    <a class="header-menu-lnk" href="#header">Início</a>
                    <a class="header-menu-lnk" href="#gallery">Veículos</a>
                    <a class="header-menu-lnk" href="#services">Serviços</a>
                    <a class="header-menu-lnk" href="#map">Contato</a>
                </nav>
            </div>
        </div>
    </div>
</header>
<main>
    <!--<div class="main">
        <img class="img-main mobile" src="assets/images/main-mobile.jpg" alt="MEGA AUTOS" />
        <img class="img-main desktop" src="assets/images/main.jpg" alt="MEGA AUTOS" />
    </div>-->
    <div id="gallery" class="section gallery">
        <h4 class="section-subtitle">Nossos veículos</h4>
        <h3 class="section-title">Os melhores negócios para você</h3>
        <label class="section-description">
            Compra, venda, consignação de veículos novos,<br class="only-above-mobile" /> seminovos, antigos, nacionais e importados.
        </label>
        <div class="container">
            <div class="vehicles">
                <div *ngFor="let v of vehicleList" [ngClass]="v.Feature ? 'feature' : ''" class="vehicle" routerLink="veiculo/{{v.IdVehicle}}">
                    <span *ngIf="v.Feature" class="feature-label">{{v.FeatureLabel}}</span>
                    <img class="vehicle-img" src="{{v.FeatureImage}}" alt="{{v.Manufacturer}} {{v.Name}}" />
                    <div class="vehicle-name">{{v.Manufacturer}} {{v.Name}}</div>
                    <div class="vehicle-model" title="{{v.Model}}">{{v.Model}}</div>
                    <div class="vehicle-value">R$ {{v.SaleValue | number}}</div>
                    <div class="vehicle-bottom-info">
                        <div class="year">{{v.Year}}</div>
                        <div class="km">{{v.Km}} km</div>
                    </div>
                    <div *ngIf="v.Feature" class="vehicle-feature-info">
                        {{v.Observations}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bg-white">
        <div class="container">
            <div class="section features">
                <h4 class="section-subtitle">Nossos diferenciais</h4>
                <h3 class="section-title">O que só a MEGA AUTOS oferece</h3>
                <label class="section-description">
                    Profissionais altamente treinados e com experiência<br class="only-above-mobile" /> para ajudar você a realizar seus sonhos.
                </label>
                <div class="row">
                    <div class="col-md-4">
                        <div class="feature animation-delay-1">
                            <i class="fal fa-cars icon"></i>
                            <b class="title">Experiência comprovada<br />no mercado automotivo</b>
                            <div class="text">
                                Há 15 anos atuando no<br />mercado de veículos e<br />financiamentos.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="feature animation-delay-2">
                            <i class="fal fa-clipboard-list-check icon"></i>
                            <b class="title">Checagem do histórico<br />completo dos veículos</b>
                            <div class="text">
                                Vistoria cautelar<br />realizada por empresas<br />credenciadas pelo DETRAN.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="feature animation-delay-3">
                            <i class="fal fa-car-wash icon"></i>
                            <b class="title">Preparação diferenciada<br />de todos os veículos</b>
                            <div class="text">
                                Revisão, higienização e<br />revitalização estética <br />dos nossos veículos.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="services" class="section services">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <h4 class="text-left section-subtitle">Nossos serviços</h4>
                    <h3 class="text-left section-title">Serviços para você</h3>
                    <label class="text-left section-description">
                        Compra e venda, consignação, assessoria e financiamento.
                    </label>
                    <div class="split"></div>
                    <div class="service">
                        <i class="fal fa-hands-helping icon"></i>
                        <div>
                            <b class="service-title">Compra, venda e consignação</b>
                            <label class="service-text">Avaliação justa, preço competitivo, transparência <br class="only-above-mobile" />e agilidade nas negociações.</label>
                        </div>
                    </div>
                    <div class="service">
                        <i class="fal fa-search-dollar icon"></i>
                        <div>
                            <b class="service-title">Assessoria na busca de veículos</b>
                            <label class="service-text">Pesquisa, avaliação, negociação e busca de veículos fora de nosso estoque com a qualidade que a MEGA AUTOS oferece.</label>
                        </div>
                    </div>
                    <div class="service">
                        <i class="fal fa-dollar-sign icon"></i>
                        <div>
                            <b class="service-title">Financiamentos</b>
                            <label class="service-text">
                                Especialistas em financiamentos, melhores taxas e aprovações do mercado! Faça sua cotação conosco.
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 offset-1">
                    <img class="img-services" src="assets/images/services.jpg" alt="Serviços MEGA AUTOS" />
                </div>
            </div>
        </div>
    </div>
    <div class="section process bg-white">
        <div class="container">
            <h4 class="section-subtitle">Nosso processo</h4>
            <h3 class="section-title">Passo a passo para o seu novo carro</h3>
            <label class="section-description">
                Aqui o cliente escolhe, compra, financia e sai com a <br class="only-above-mobile" />documentação e transferência com a maior agilidade.
            </label>
            <div class="row">
                <div class="col-md-4">
                    <div class="step animation-delay-1">
                        <i class="fal fa-hand-point-up icon"></i>
                        <b class="step-title">Escolha o seu carro</b>
                        <label class="step-description">
                            Escolha seu veículo em nosso<br class="only-above-mobile" /> estoque ou fora dele.
                        </label>
                        <span class="step-legend">Os melhores veículos</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="step feature animation-delay-2">
                        <i class="fal fa-calculator icon"></i>
                        <b class="step-title">Simule o financiamento</b>
                        <label class="step-description">
                            Melhores condições para<br class="only-above-mobile" /> você e seu veículo.
                        </label>
                        <span class="step-legend">As melhores taxas</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="step animation-delay-3">
                        <i class="fal fa-smile icon"></i>
                        <b class="step-title">Aproveite seu carro!</b>
                        <label class="step-description">
                            Seu carro pronto para uso <br class="only-above-mobile" />e com garantia de 3 meses.
                        </label>
                        <span class="step-legend">Sem complicações</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="section bg-white">
        <div class="container">
            <div class="row">
                <div class="col">
                    <h4 class="section-subtitle">Garantia MEGA AUTOS</h4>
                    <h3 class="section-title">As melhores marcas</h3>
                    <label class="section-description">
                        Veículos com qualidade, sem restrições e com documentação em dia.<br />Trabalhamos com todas as marcas nacionais e importadas.
                    </label>
                </div>
            </div>
            <div class="brands">
                <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
                    <div ngxSlickItem *ngFor="let slide of slides" class="slide">
                        <img class="img-brand" src="{{ slide.img }}" alt="{{slide.alt}}">
                    </div>
                </ngx-slick-carousel>
            </div>
        </div>
    </div>
</main>
<app-footer></app-footer>
<a href="https://api.whatsapp.com/send?phone=551936310101&text=Ol%C3%A1%2C%20tenho%20interesse%20em%20um%20ve%C3%ADculo%5Cservi%C3%A7o%20Mega%20Autos.%20Favor%20entrar%20em%20contato." class="lnk-whatsapp">
    <i class="fab fa-whatsapp"></i>
</a>